import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { Button } from "@/components/button";
/** Toolbar that lays out filter chips and stages apply/clear so the query only refetches on apply. */
export function FilterBar(_ref) {
  var children = _ref.children,
    onApply = _ref.onApply,
    onClear = _ref.onClear,
    canApply = _ref.canApply,
    canClear = _ref.canClear;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap items-center gap-2"
  }, children, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "ghost",
    "data-testid": "filters-clear",
    disabled: !canClear,
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.FILTERS_CLEAR);
      onClear();
    }
  }, t("clear", {
    defaultValue: "Clear"
  })), /*#__PURE__*/React.createElement(Button, {
    "data-testid": "filters-apply",
    disabled: !canApply,
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.FILTERS_APPLY);
      onApply();
    }
  }, t("apply", {
    defaultValue: "Apply"
  }))));
}